export default __webpack_public_path__ + "static/media/success.24fe0184.svg";